import i18next from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    load: 'languageOnly',
    backend: {
      loadPath: 'locales/{{lng}}/translation.json',
      allowMultiLoading: false,
      crossDomain: true,
      withCredentials: false,
    },
    react: {
      useSuspense: false,
    },
  })

export default i18next
